// Backorder Notification Modal
// Shows when staff/admin changes order or item status to backordered

import { useState } from "react";
import PropTypes from "prop-types";
import {
	Box,
	Button,
	Stack,
	Modal,
	Typography,
	FormControlLabel,
	Checkbox,
} from "custom_exports/material_ui_items";

function BackorderNotificationModal(props) {
	//--------------------------------- variables ---------------------------------//
	const {
		open,
		onClose,
		onConfirm,
		itemType = "order" // "order" or "item"
	} = props;

	const [notifyCustomer, setNotifyCustomer] = useState(false);

	//--------------------------------- functions ---------------------------------//
	const handleConfirm = () => {
		// Validate that onConfirm is a function before calling
		if (typeof onConfirm === "function") {
			onConfirm(notifyCustomer);
		}
		setNotifyCustomer(false); // Reset for next use
	};

	const handleClose = () => {
		// Validate that onClose is a function before calling
		if (typeof onClose === "function") {
			onClose();
		}
		setNotifyCustomer(false); // Reset for next use
	};

	//--------------------------------- contents ----------------------------------//
	const content = (
		<Modal open={open} onClose={handleClose}>
			<Box
				sx={{
					position: "absolute",
					top: "30%",
					left: "50%",
					transform: "translate(-50%, -30%)",
					width: 400,
					bgcolor: "white",
					p: 4,
					pb: 2,
					borderRadius: 3,
				}}
			>
				<Typography variant="h6" sx={{ mb: 2 }}>
					Mark as Backordered
				</Typography>
				<Typography variant="body2" sx={{ color: "grey.600", mb: 2 }}>
					{itemType === "order"
						? "This will mark the entire order as backordered."
						: "This will mark this item as backordered."}
				</Typography>
				<FormControlLabel
					control={
						<Checkbox
							checked={notifyCustomer}
							onChange={(event) => setNotifyCustomer(event.target.checked)}
							style={{
								paddingTop: 0,
								paddingBottom: 0,
								paddingRight: 0,
								transform: "scale(0.8)",
							}}
						/>
					}
					label={
						<Typography fontSize={13}>
							Send backorder notification email to customer
						</Typography>
					}
				/>
				<Stack direction="row" justifyContent="flex-end" mt={3} spacing={1}>
					<Button color="inherit" onClick={handleClose}>
						Cancel
					</Button>
					<Button variant="contained" onClick={handleConfirm}>
						Confirm
					</Button>
				</Stack>
			</Box>
		</Modal>
	);

	return content;
}

BackorderNotificationModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	itemType: PropTypes.oneOf(["order", "item"]),
};

export default BackorderNotificationModal;
